"use strict";

var _pluralRules = _interopRequireDefault(require("./plural-rules"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (typeof Intl === 'undefined') {
  if (typeof global !== 'undefined') {
    global.Intl = {
      PluralRules: _pluralRules.default
    };
  } else if (typeof window !== 'undefined') {
    window.Intl = {
      PluralRules: _pluralRules.default
    };
  } else {
    (void 0).Intl = {
      PluralRules: _pluralRules.default
    };
  }
} else if (!Intl.PluralRules) {
  Intl.PluralRules = _pluralRules.default;
} else {
  var test = ['en', 'es', 'ru', 'zh'];
  var supported = Intl.PluralRules.supportedLocalesOf(test);
  if (supported.length < test.length) Intl.PluralRules = _pluralRules.default;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/intl-pluralrules/polyfill.js
// module id = 872
// module chunks = 0